import { useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Button, Input } from '@rb/ui'
import styles from './Auth.module.css'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = params.get('token') ?? ''

  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (password !== confirm) {
      setError('Passwörter stimmen nicht überein')
      return
    }
    setError('')
    setLoading(true)
    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, password }),
      })
      if (!res.ok) {
        const data = (await res.json()) as { error?: string }
        setError(data.error ?? 'Zurücksetzen fehlgeschlagen')
        return
      }
      navigate('/login')
    } catch {
      setError('Verbindungsfehler. Bitte erneut versuchen.')
    } finally {
      setLoading(false)
    }
  }

  if (!token) {
    return (
      <div className={styles.card}>
        <h1 className={styles.heading}>Ungültiger Link</h1>
        <p className={styles.error}>Dieser Link ist ungültig oder abgelaufen.</p>
        <div className={styles.footer}>
          <Link to="/forgot-password" className={styles.link}>
            Neuen Link anfordern
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>Neues Passwort</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          type="password"
          label="Neues Passwort"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="new-password"
          required
        />
        <Input
          type="password"
          label="Passwort bestätigen"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
          autoComplete="new-password"
          required
        />
        {error && <p className={styles.error}>{error}</p>}
        <Button type="submit" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Wird gespeichert…' : 'Passwort setzen'}
        </Button>
      </form>
    </div>
  )
}
